<template>
  <div>
    <!-- 申请协议的对话框 -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="40%" modal-append-to-body append-to-body
      close-on-click-modal @closed="handleClose">
      <el-form size="small" :model="form" :rules="rules" ref="form" label-width="80px">
        <!-- 协议名称 -->
        <el-form-item label="协议名称" prop="name">
          <el-select :disabled="optionType === 'view'" size="small" v-model="form.name" placeholder="请选择协议名称"
            style="width: 100%;;margin-right: 20px;" clearable @change="nameChange">
            <el-option v-for="(item, index) in protocolList.value" :key="index" :label="item.name"
              :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 协议版本 -->
        <el-form-item label="协议版本" prop="version">
          <el-input :disabled="optionType === 'view'" size="small" v-model="form.version" maxlength="200"
            placeholder="请输入协议版本" clearable></el-input>
        </el-form-item>
        <!-- 富文本 -->
        <el-form-item label="协议内容" prop="content">
          <avue-ueditor ref="editor" v-model="form.content" v-bind="options"></avue-ueditor>
        </el-form-item>
        <el-form-item>
          <div @click="handleContent">
            <UploadBtn ref="uploadBtn" size="small" type="primary" :currentUrl="form.url" :content="content"
              :title="form.name" :bgColor="form.backgroundColor" @uploadSuccess="uploadSuccess"
              @uploadFail="uploadFail">预览</UploadBtn>
          </div>
        </el-form-item>
        <!-- 背景色 -->
        <el-form-item label="背景色" prop="backgroundColor">
          <el-input size="small" placeholder="请输入背景色" v-model="form.backgroundColor" clearable></el-input>
        </el-form-item>
        <!-- 协议地址 -->
        <el-form-item label="协议地址">
          <span>{{ form.url }}</span>
        </el-form-item>
        <!-- 说明 -->
        <el-form-item label="说明" prop="remark">
          <el-input :disabled="optionType === 'view' && larkApprovalStatus === 1" size="small" v-model="form.remark"
            maxlength="200" placeholder="请输入说明" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button v-if="!(this.larkApprovalStatus === 1 && this.optionType === 'view')" size="small" type="primary"
          @click="submitForm" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addProtocol, updateProtocol, } from '@/api/protocolCompliance/protocolManage';
import Message from '@/components/Message';
import UploadBtn from './UploadViewBtn/index.vue';
export default {
  name: 'WebSaaSAdd',
  inject: ['protocolList', 'loadList'],
  components: {
    UploadBtn
  },
  computed: {
    /** 富文本是否改动过 */
    contentChange() {
      console.log('富文本是否改动过contentChange', this.form.content, this.preContent);
      return this.form.content !== this.preContent;
    }
  },
  data() {
    return {
      loading: false,
      /** 控制表单是否已初始化的标记 */
      isFormInitialized: false,
      /** 对话框标题 */
      title: '申请协议',
      /** 操作类型 */
      optionType: 'add',
      /** 签报状态 */
      larkApprovalStatus: '',
      /** 对话框是否可见 */
      dialogVisible: false,
      /** 传递的富文本内容 */
      content: '',
      /** 传递上传btn的url */
      currentUrl: '',
      /** 富文本上一次的内容 */
      preContent: '',
      /** 初始的协议地址 */
      initialUrl: '',
      form: {
        /** 协议模板code */
        code: '',
        /** 协议名称 */
        name: '',
        /** 协议版本 */
        version: '',
        /** 协议内容 */
        content: "",
        /** 背景色 */
        backgroundColor: '',
        /** 说明 */
        remark: '',
        /** 协议地址 */
        url: '',
      },
      /** 富文本配置 */
      options: {
        action: "/lebo-resource/oss/endpoint/put-file",
        propsHttp: { res: "data", url: "link" },
        customConfig: {
          focus: false,
          fontNames: [{ name: "黑体", value: "黑体" }, { name: '楷体', value: "楷体" }, { name: '宋体', value: '宋体' }, { name: "仿宋体", value: '仿宋体' },
          { name: '隶书', value: '隶书' }, { name: '方正黑体', value: '方正黑体' }, { name: '方正书宋', value: '方正书宋' }, { name: '方正仿宋', value: '方正仿宋' }
            , { name: '方正楷体', value: '方正楷体' }
          ],
        }
      },
      rules: {
        name: [
          { required: true, message: '请选择协议名称', trigger: ['change', 'blur'] },
        ],
        version: [
          { required: true, message: '请输入协议版本', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              // 验证格式
              // 允许多个小数点的版本号格式
              const versionPattern = /^\d+(\.\d+)*$/;
              if (!versionPattern.test(value)) {
                callback(new Error('请输入正确的版本号格式'));
              } else {
                callback();
              }
            }
          }
        ],
        content: [
          { required: true, message: '请输入协议内容', trigger: ['change'] },
        ],
      },
    };
  },
  methods: {
    /** 协议名称选择事件 */
    nameChange(val) {
      console.log('协议名称选择事件nameChange', val);
      if (val) {
        this.form.code = this.protocolList.value.find(item => item.name === this.form.name).code
      }
    },
    /** 确认保存 */
    submitForm() {
      /** 如果没有协议地址就是还没有上传 */
      if (!this.form.url) {
        Message.error('请上传协议地址')
        return
      }
      /** 校验表单 */
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          console.log('表单校验通过');
          /** 只有富文本内容不相同的时候 才调用上传组件的上传方法 */
          if (this.contentChange) {
            console.log('调用上传组件的真实上传方法');
            const res = await this.$refs.uploadBtn.publicUploadAPi(true)
            console.log('上传组件的上传方法的响应', res);
            this.form.url = res
          }
          /** 根据不同操作类型执行新增 or 修改 */
          if (this.optionType === 'add') {
            /** 准备新增协议模板 */
            this.add()
          } else {
            /** 准备修改协议模板 */
            this.edit()
          }
        }
      });
      console.log('submitForm', this.form);
    },
    /** 新增的方法 */
    async add() {
      this.loading = true;
      const params = { ...this.form }
      try {
        const { data } = await addProtocol(params)
        this.loading = false;
        console.log('新增协议模板接口的响应', data);
        if (data.code === 200) {
          Message.success('新增成功')
          this.loadList()
          this.hide()
        }
      } catch (error) {
        this.loading = false;
      }
    },
    /** 编辑的方法 */
    async edit() {
      this.loading = true;
      const params = { ...this.form }
      try {
        const { data } = await updateProtocol({
          id: params.id,
          content: params.content,
          remark: params.remark,
          url: params.url
        })
        console.log('修改协议模板接口的响应', data);
        this.loading = false;
        if (data.code === 200) {
          Message.success('修改成功')
          this.loadList()
          this.hide()
        }
      } catch (error) {
        this.loading = false;
      }
    },
    //^ ^--------------富文本相关-------------^ ^
    /** 富文本移除html标签 */
    removeHtmlTags(str) {
      const regex = /<[^>]*>/g;
      return str.replace(regex, '');
    },
    /** 富文本是否禁用 */
    disabledEditor() {
      /** 富文本是否要禁用 */
      if (this.larkApprovalStatus === 1 && this.optionType === 'view') {
        this.$nextTick(() => {
          console.log('富文本禁用',);
          this.$refs.editor.editor.disable()
        });
      } else {
        this.$nextTick(() => {
          console.log('富文本启用',);
          this.$refs.editor.editor.enable()
        });
      }
    },
    /** 处理富文本内容事件 */
    handleContent() {
      /** 富文本相同 传空 */
      if (!this.contentChange) {
        console.log('富文本内容相同handleContent', this.form.content);
        this.content = ''
      } else {
        console.log('富文本内容不相同handleContent', this.form.content);
        /** 富文本内容不相同那就把富文本内容传递给组件 */
        this.content = this.form.content
      }
    },
    uploadSuccess(url) {
      console.log('富文本内容上传成功uploadSuccess', url);
      this.form.url = url;
    },
    uploadFail(err) {
      console.log('富文本内容上传失败uploadFail', err);
    },

    //^ ^--------------对话框自身的方法-------------^ ^
    show(title, optionType, row) {

      this.title = title || '申请协议'
      this.optionType = optionType || 'add'
      if (row) {
        console.log('申请协议的对话框show', row);
        this.larkApprovalStatus = row.larkApprovalStatus
        /** 富文本是否禁用处理 */
        this.disabledEditor()
        /** 表单重新赋值 */
        this.form.code = row.code
        this.form.name = row.name
        this.form.version = row.version
        this.form.content = row.content
        this.form.remark = row.remark
        this.form.url = row.url
        /** 满足该条件可以修改 需要id */
        /** this.larkApprovalStatus === 0 && this.optionType === 'view' */
        if (this.larkApprovalStatus === 0 && this.optionType === 'view') {
          /** 可以修改的时候需要记录id */
          this.form.id = Number(row.id)
        }
        /** 存储富文本的值 用于比较富文本内容是否变化 */
        this.preContent = row.content
        /** 同时记录协议地址 */
        this.initialUrl = row.url
        // 配置 onchange 回调函数
        this.$nextTick(() => {
          this.$refs.editor.editor.config.onchange = (newHtml) => {
            console.log("change 之后最新的 html", newHtml, 'preContent', this.preContent);
            if (newHtml !== this.preContent) {
              console.log('富文本内容改动协议地址置为空');
              /** 富文本内容改动协议地址置为空 */
              this.form.url = ''
              this.form.content = newHtml
            } else if (newHtml === this.preContent) {
              console.log('富文本内容不改动协议地址要恢复');
              /** 如果富文本内容不改动协议地址要恢复 */
              this.form.url = this.initialUrl
            }
          };
        })
      }
      this.dialogVisible = true;
      /** 配置富文本失焦验证规则 */
      this.$nextTick(() => {
        this.$refs.editor.editor.config.onblur = () => {
          this.$nextTick(() => {
            console.log('富文本失焦验证规则', this.$refs.editor);
            this.$refs.form.validateField('content');
          });
        }
      })
    },
    hide() {
      this.dialogVisible = false;
    },
    handleClose() {
      /** 清空表单值 */
      this.form.code = '',
        this.form.name = '',
        this.form.version = '',
        this.form.content = '',
        this.form.remark = '',
        this.form.backgroundColor = '',
        this.form.url = ''
      /** 清空初始url */
      this.initialUrl = ''
      /** 清除验证规则 */
      this.$refs.form.clearValidate()
    },
  },
};
</script>

<style lang="scss" scoped></style>
